import { intl, mathService } from '@approvalmax/utils';
import { memo } from 'react';

import { messages } from './NetSuiteJournalEntryFooter.messages';
import {
    AmountLabel,
    AmountValue,
    InfoTable,
    OutByValue,
    Separator,
    Wrapper,
} from './NetSuiteJournalEntryFooter.styles';
import { NetSuiteJournalEntryFooterProps } from './NetSuiteJournalEntryFooter.types';

export const NetSuiteJournalEntryFooter = memo<NetSuiteJournalEntryFooterProps>((props) => {
    const {
        currency,
        currencyPrecision,
        debitTotal,
        creditTotal,
        debitTotalTax,
        creditTotalTax,
        debitSubTotal,
        creditSubTotal,
    } = props;

    return (
        <Wrapper>
            <InfoTable>
                <thead>
                    <tr>
                        <td />

                        <AmountLabel>{`${messages.debitTitle} (${currency})`}</AmountLabel>

                        <AmountLabel>{`${messages.creditTitle} (${currency})`}</AmountLabel>
                    </tr>
                </thead>

                <tbody>
                    {(debitTotalTax > 0 || creditTotalTax > 0) && (
                        <>
                            <tr>
                                <AmountLabel>{messages.subtotalTitle}</AmountLabel>

                                <AmountValue>{intl.formatNumber(debitSubTotal, currencyPrecision)}</AmountValue>

                                <AmountValue>{intl.formatNumber(creditSubTotal, currencyPrecision)}</AmountValue>
                            </tr>

                            <tr>
                                <AmountLabel>{messages.totalTaxTitle}</AmountLabel>

                                <AmountValue>{intl.formatNumber(debitTotalTax, currencyPrecision)}</AmountValue>

                                <AmountValue>{intl.formatNumber(creditTotalTax, currencyPrecision)}</AmountValue>
                            </tr>
                        </>
                    )}

                    <tr>
                        <AmountLabel>{messages.totalTitle}</AmountLabel>

                        <AmountValue>{intl.formatNumber(debitTotal, currencyPrecision)}</AmountValue>

                        <AmountValue>{intl.formatNumber(creditTotal, currencyPrecision)}</AmountValue>
                    </tr>

                    {debitTotal !== creditTotal && (
                        <>
                            <tr>
                                <td colSpan={3}>
                                    <Separator />
                                </td>
                            </tr>

                            <tr>
                                <td />

                                <AmountLabel>{messages.totalIsOutBy}</AmountLabel>

                                <OutByValue>
                                    {intl.formatNumber(
                                        mathService.subtract(debitTotal, creditTotal),
                                        currencyPrecision
                                    )}
                                </OutByValue>
                            </tr>
                        </>
                    )}
                </tbody>
            </InfoTable>
        </Wrapper>
    );
});

NetSuiteJournalEntryFooter.displayName = 'NetSuiteJournalEntryFooter';
